var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Big"},[_c('div',{staticClass:"Big-top"},[_vm._m(0),_c('kaobo')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex"},[_c('img',{staticClass:"topimg",attrs:{"src":require("@/assets/modal/mjtb.png")}}),_c('div',{staticClass:"text"},[_vm._v(" 设备统计 ")])])
}]

export { render, staticRenderFns }